
export default "/assets/sparkles-micro.3304aebe.svg"